export const stripQueryParameters = (path: string) => path.replace(/:[^/]+/, '')
